import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Pagination from '@material-ui/lab/Pagination';
import React, { isValidElement } from 'react';
import { humanBoolean, humanDate } from 'utils/ui.utils';
import { useIsMobile, useWindowDimensions } from 'utils/window';
import './list.css';
const isCustomProp = (props) => 'customRenderValue' in props;
const isDateLikeString = (str) => {
    return /^\d{4}-\d\d-\d\d-/.test(str);
};
const formatValue = (data) => {
    if (typeof data === 'string') {
        if (isDateLikeString(data)) {
            return humanDate(data);
        }
        return data;
    }
    if (typeof data === 'boolean') {
        return humanBoolean(data);
    }
    if (typeof data === 'number') {
        return data.toString();
    }
    if (data instanceof Date) {
        return humanDate(data);
    }
    if (isValidElement(data)) {
        return data;
    }
    return null;
};
export const List = ({ items, columns, onClick, isClickable, showHeaders = true, rowColors = false, total = 0, label, totalPages = 0, loading, page, handlePageChange, listSource = '', margin = true }) => {
    const isMobile = useIsMobile();
    const { width } = useWindowDimensions();
    return (React.createElement(React.Fragment, null,
        label && !loading && (React.createElement("div", { className: "data-count" },
            total,
            " ",
            label,
            " found")),
        loading && (React.createElement("div", { className: "data-count" },
            React.createElement(CircularProgress, { size: "1.2rem", style: { color: '#290e88' } }))),
        width > 600 ? (React.createElement("div", { className: "list__container-container" },
            React.createElement("div", { className: "list__container" },
                showHeaders && (React.createElement(Grid, { className: "list__container-header", container: true, item: true, xs: 12 }, columns.map((item) => {
                    if (!item.name) {
                        return null;
                    }
                    return (React.createElement(Grid, { className: "list__header", item: true, key: item.name, xs: item.xs ?? 1 },
                        React.createElement("span", { className: item.className }, item.name.toUpperCase())));
                }))),
                items?.map((item, idx) => {
                    return (React.createElement(Grid, { className: `${rowColors ? 'row-colors' : ''} ${idx % 2 === 0 ? 'even' : 'odd'}  list__container-body ${idx === 0 ? 'first' : ''} ${idx === items.length - 1 ? 'end' : ''}
                    ${idx !== 0 && idx !== items.length - 1 ? 'middle' : ''}
                    `, container: true, item: true, 
                        // TODO: This is bad, we need an id per row in the future
                        // eslint-disable-next-line react/no-array-index-key
                        key: idx, xs: 12 }, columns.map((col) => {
                        return (React.createElement(Grid, { className: `${col.isClickable !== false && isClickable?.(item)
                                ? 'pointer'
                                : ''} list__body`, item: true, key: col.name, onClick: () => {
                                if (col.isClickable === false) {
                                    return;
                                }
                                if (isClickable?.(item)) {
                                    onClick?.(item);
                                }
                            }, xs: col.xs ?? 1 },
                            React.createElement("div", { className: "text-ellipsis", "data-ph-mask": col.replayMasked === true || undefined, "data-test": "item" }, isCustomProp(col)
                                ? col.customRenderValue(item)
                                : formatValue(item[col.id]))));
                    })));
                })))) : (React.createElement("div", { className: listSource === 'key'
                ? 'list__container-container-key'
                : 'list__container-container' },
            React.createElement("div", { className: "list__container" },
                showHeaders && (React.createElement(Grid, { className: listSource === 'jobs'
                        ? 'list__container-header list__container-jobs'
                        : 'list__container-header', item: true, xs: 12 }, columns.map((item) => (React.createElement(Grid, { className: "list__header", item: true, key: item.name, xs: item.xs ?? 1 },
                    React.createElement("span", { className: item.className }, item.name.toUpperCase())))))),
                items?.map((item, idx) => {
                    return (React.createElement(Grid, { className: `${rowColors ? 'row-colors' : ''} ${idx % 2 === 0 ? 'even' : 'odd'}  list__container-body ${idx === 0 ? 'first' : ''} ${idx === items.length - 1 ? 'end' : ''}
                    ${idx !== 0 && idx !== items.length - 1 ? 'middle' : ''}
                    `, item: true, 
                        // eslint-disable-next-line react/no-array-index-key
                        key: idx, xs: 12 }, columns.map((col) => {
                        return (React.createElement(Grid, { className: `${col.isClickable !== false && isClickable?.(item)
                                ? 'pointer'
                                : ''} list__body ${isMobile ? `list__body__${listSource}` : ''}`, item: true, key: col.name, onClick: () => {
                                if (col.isClickable === false) {
                                    return;
                                }
                                if (isClickable?.(item)) {
                                    onClick?.(item);
                                }
                            }, xs: 6 },
                            React.createElement("div", { className: "text-ellipsis", "data-ph-mask": col.replayMasked === true || undefined }, isCustomProp(col)
                                ? col.customRenderValue(item)
                                : formatValue(item[col.id]))));
                    })));
                })))),
        margin && React.createElement("div", { className: "u-margin-bottom-large" }, "\u00A0"),
        totalPages > 1 && (React.createElement(Pagination, { count: totalPages, onChange: (event, newPage) => {
                if (page === newPage) {
                    return;
                }
                window.scrollTo(0, 0);
                handlePageChange?.(event, newPage);
            }, page: page, shape: "rounded", variant: "outlined" })),
        margin && React.createElement("div", { className: "u-margin-bottom-large" }, "\u00A0")));
};
